import { z } from 'zod/v4';
import { timeDashboardSchema } from './time';

export const copiedPanelSourceSchema = z.object({
  /** Type of the resource the panel was copied from (e.g., 'dashboard') */
  type: z.string(),
  /** Slug of the resource the panel was copied from (e.g., 'example-dashboard') */
  slug: z.string().optional(),
  /** Hostname where the panel was copied */
  hostname: z.string().optional(),
  /** The page-level time range at the source when the panel was copied */
  time: timeDashboardSchema.optional(),
});

export type CopiedPanelSource = z.TypeOf<typeof copiedPanelSourceSchema>;
